import { render, staticRenderFns } from "./Roadlog.vue?vue&type=template&id=25cd981f&scoped=true&"
import script from "./Roadlog.vue?vue&type=script&lang=js&"
export * from "./Roadlog.vue?vue&type=script&lang=js&"
import style0 from "./Roadlog.vue?vue&type=style&index=0&id=25cd981f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cd981f",
  null
  
)

export default component.exports